(function () {
  const rootSelector = "[data-rs02-purchase-options]";
  const cardSelector = "[data-rs02-quantity-card]";
  const planSelector = "[data-rs02-plan-radio]";

  function findProductForms(container) {
    const formId = container.dataset.formId;
    const primaryForm = formId ? document.getElementById(formId) : null;
    const productId = container.dataset.productId || (primaryForm && primaryForm.dataset ? primaryForm.dataset.productId : "");
    const forms = [];

    if (primaryForm) forms.push(primaryForm);
    if (productId) {
      document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
        const productInput = form.querySelector('input[name="product-id"]');
        const isProductForm = form.dataset.productId === productId || (productInput && productInput.value === productId);
        if (!isProductForm) return;
        if (!forms.includes(form)) forms.push(form);
      });
    }

    if (!forms.length) {
      const section = container.closest(".shopify-section") || container.closest("section") || document;
      section.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
        if (!forms.includes(form)) forms.push(form);
      });
    }

    return forms;
  }

  function ensureHiddenInput(form, name) {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }
    return input;
  }

  function removeInput(form, name) {
    const input = form.querySelector(`input[name="${name}"]`);
    if (input) input.remove();
  }

  function syncQuantity(container, quantity) {
    const value = Math.max(1, Number(quantity || 1));

    findProductForms(container).forEach((form) => {
      const quantityInput = ensureHiddenInput(form, "quantity");
      quantityInput.value = String(value);
      quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function syncVariant(container, variantId) {
    if (!variantId) return;

    findProductForms(container).forEach((form) => {
      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;
      variantInput.value = String(variantId);
      variantInput.disabled = false;
      variantInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function syncSellingPlan(container, planId) {
    findProductForms(container).forEach((form) => {
      if (!planId) {
        removeInput(form, "selling_plan");
        return;
      }

      const input = ensureHiddenInput(form, "selling_plan");
      input.value = String(planId);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function syncAvailability(container, available) {
    findProductForms(container).forEach((form) => {
      form.querySelectorAll('button[name="add"], button[type="submit"], input[type="submit"]').forEach((button) => {
        button.disabled = !available;
        button.setAttribute("aria-disabled", available ? "false" : "true");
      });
    });
  }

  function getSelectedPurchaseType(container) {
    const selected = container.querySelector(`${planSelector}:checked`);
    return selected ? selected.dataset.purchaseType || "one_time" : container.dataset.selectedPurchaseType || "one_time";
  }

  function setText(container, selector, value) {
    const node = container.querySelector(selector);
    if (node) node.textContent = value || "";
  }

  function setSubscribeState(container, card) {
    const subscribeRow = container.querySelector("[data-rs02-subscribe-row]");
    const subscribeRadio = container.querySelector("[data-rs02-subscribe-radio]");
    const planId = card.dataset.sellingPlanId || "";
    const hasPlan = Boolean(planId);

    if (subscribeRow) subscribeRow.classList.toggle("is-disabled", !hasPlan);
    if (subscribeRadio) {
      subscribeRadio.value = planId;
      subscribeRadio.disabled = !hasPlan;
    }

    setText(container, "[data-rs02-selling-plan-name]", card.dataset.sellingPlanName || "Subscription plan unavailable for this package");
    setText(container, "[data-rs02-subscribe-price]", card.dataset.subscribePrice || "-");

    if (!hasPlan && subscribeRadio && subscribeRadio.checked) {
      const oneTime = container.querySelector(`${planSelector}[data-purchase-type="one_time"]`);
      if (oneTime) oneTime.checked = true;
    }
  }

  function syncSelectedPlan(container) {
    const purchaseType = getSelectedPurchaseType(container);
    const selectedCard = container.querySelector(`${cardSelector}.is-selected`) || container.querySelector(cardSelector);
    const planId = selectedCard ? selectedCard.dataset.sellingPlanId || "" : "";

    container.dataset.selectedPurchaseType = purchaseType;
    setText(container, "[data-rs02-frequency-label]", purchaseType === "subscribe" && planId ? "Subscribe and save" : "One-time purchase");
    syncSellingPlan(container, purchaseType === "subscribe" ? planId : "");
  }

  function setSelectedCard(container, selectedCard) {
    if (!selectedCard) return;

    container.querySelectorAll(cardSelector).forEach((card) => {
      const isSelected = card === selectedCard;
      card.classList.toggle("is-selected", isSelected);
      card.setAttribute("aria-pressed", isSelected ? "true" : "false");
      card.setAttribute("aria-checked", isSelected ? "true" : "false");
    });

    setText(container, "[data-rs02-quantity-label-value]", selectedCard.dataset.label || "1 Box");
    setText(container, "[data-rs02-one-time-price]", selectedCard.dataset.oneTimePrice || "");
    const description = (container.dataset.oneTimeDescription || "")
      .replaceAll("[sachets]", selectedCard.dataset.sachetsCount || "")
      .replaceAll("[unit_price]", selectedCard.dataset.oneTimeUnitPrice || "");
    setText(container, "[data-rs02-one-time-description]", description);
    setText(container, "[data-rs02-include-one]", selectedCard.dataset.includeOne || "");
    setText(container, "[data-rs02-include-two]", selectedCard.dataset.includeTwo || "");
    setText(container, "[data-rs02-include-three]", selectedCard.dataset.includeThree || "");

    syncQuantity(container, selectedCard.dataset.quantity);
    syncVariant(container, selectedCard.dataset.variantId);
    syncAvailability(container, selectedCard.dataset.available !== "false");
    setSubscribeState(container, selectedCard);
    syncSelectedPlan(container);
  }

  function handleCardKeydown(container, event) {
    const key = event.key;
    if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(key)) return;

    const cards = Array.from(container.querySelectorAll(cardSelector));
    if (!cards.length) return;

    const currentIndex = cards.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    if (key === "Home") nextIndex = 0;
    if (key === "End") nextIndex = cards.length - 1;
    if (key === "ArrowLeft" || key === "ArrowUp") nextIndex = Math.max(0, currentIndex - 1);
    if (key === "ArrowRight" || key === "ArrowDown") nextIndex = Math.min(cards.length - 1, currentIndex + 1);

    if (nextIndex !== currentIndex) {
      event.preventDefault();
      cards[nextIndex].focus();
      setSelectedCard(container, cards[nextIndex]);
    }
  }

  function setup(container) {
    if (!container || container.dataset.rs02Initialized === "true") return;
    container.dataset.rs02Initialized = "true";

    const cards = Array.from(container.querySelectorAll(cardSelector));
    const selectedCard = cards.find((card) => card.classList.contains("is-selected")) || cards[0];

    cards.forEach((card) => {
      card.addEventListener("click", () => setSelectedCard(container, card));
      card.addEventListener("keydown", (event) => handleCardKeydown(container, event));
    });

    container.querySelectorAll(planSelector).forEach((radio) => {
      radio.addEventListener("change", () => {
        if (radio.checked) syncSelectedPlan(container);
      });
    });

    if (selectedCard) setSelectedCard(container, selectedCard);
  }

  function init(scope) {
    const context = scope || document;
    context.querySelectorAll(rootSelector).forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
